import { type SessionListHost } from '../session-list/session-list-host';
import { SessionListHostProvider } from '../session-list/session-list-host-context';
import {
  LazyConsolidatedSessionsBar as ConsolidatedSessionsBar,
  LazySessionsBar as SessionsBar,
  LazySessionsBarV2 as SessionsBarV2,
} from './LazySessionsBars';

/**
 * Renders the appropriate sessions bar variant based on feature flags.
 * Shared by ResizableMenuPanels (flag-off path) and SessionsListPanelFixed (flag-on path).
 */
export const SessionsBarContent = ({ host }: { host: SessionListHost }) => {
  const sessionListVersion = host.sessionApp.useSessionListVersion();

  const bar =
    sessionListVersion === 'consolidated' ? (
      <ConsolidatedSessionsBar host={host} />
    ) : sessionListVersion === 'v2' ? (
      <SessionsBarV2 host={host} />
    ) : (
      <SessionsBar host={host} />
    );

  return (
    <SessionListHostProvider host={host}>
      <div className="flex size-full min-h-0 flex-col">{bar}</div>
    </SessionListHostProvider>
  );
};
